import { Iodine } from "@kingshott/iodine";

export default (labels) => ({
  iodineInstance: null,
  inputElements: [],
  labels,

  init() {
    this.inited = false;

    if (document.querySelector("body").classList.contains("neos-backend")) {
      return;
    }

    this.inited = true;

    this.iodineInstance = new Iodine();
    this.iodineInstance.messages.required = this.labels.required;
    this.iodineInstance.messages.email = this.labels.email;

    this.inputElements = [
      ...this.$el.querySelectorAll(
        ".form-element[data-rules],.form-inputs-list[data-rules]"
      ),
    ];
    this.initDomData();
    this.updateErrorMessages();
    this.bindEvents();
  },

  initDomData() {
    this.inputElements.map((element) => {
      this[element.id] = { blurred: false };
    });
  },

  updateErrorMessages() {
    this.inputElements.map((element) => {
      this[element.id].errorMessage = this.getErrorMessage(element);
    });
  },

  getErrorMessage(element) {
    const error = this.iodineInstance.is(
      this.getElementValue(element),
      JSON.parse(element.dataset.rules)
    );
    if (error !== true && this[element.id].blurred) {
      return this.iodineInstance.getErrorMessage(error);
    }
    return "";
  },

  getElementValue(element) {
    const actualElement = element.matches(".form-inputs-list")
      ? element.querySelector(":checked")
      : element;
    return actualElement ? actualElement.value : null;
  },

  getEventElement(event) {
    return event.target.matches("input[type=radio], input[type=checkbox]")
      ? event.target.closest("[id]")
      : event.target;
  },

  change(event) {
    const element = this.getEventElement(event);
    if (!this[element.id]) {
      return false;
    }

    this[element.id].blurred = true;
    this.updateErrorMessages();
  },

  bindEvents() {
    window.addEventListener("recaptchaCallbackFormSubmit", () => {
      this.$refs.form.submit();
    });
  },

  form: {
    ["@focusout"](event) {
      if (!this.inited) {
        return;
      }
      this.change(event);
    },
    ["@input"](event) {
      if (!this.inited) {
        return;
      }
      this.change(event);
    },
    ["@submit.prevent"](event) {
      if (!this.inited) {
        return;
      }

      const invalidElements = this.inputElements.filter((input) => {
        return (
          this.iodineInstance.is(
            this.getElementValue(input),
            JSON.parse(input.dataset.rules)
          ) !== true
        );
      });

      if (invalidElements.length > 0) {
        event.preventDefault();
        document.getElementById(invalidElements[0].id).scrollIntoView();
        this.inputElements.map((input) => {
          this[input.id].blurred = true;
        });
        this.updateErrorMessages();
      } else {
        // eslint-disable-next-line no-undef
        if (typeof grecaptcha !== "undefined") {
          // eslint-disable-next-line no-undef
          grecaptcha.execute();
        } else {
          event.target.submit();
        }
      }
    },
  },
  label: {
    ["@click"](event) {
      if (document.querySelector("body").classList.contains("neos-backend")) {
        event.preventDefault();
        // event.stopPropagation();
      }
    },
  },
});
